const mutations = {
  setB2bGroups(state, input) {
    state.b2b.groups = input;
  }
};

export default mutations;
